'use client'

import {useEffect, useLayoutEffect as vanillaUseLayoutEffect} from 'react'
import {isBrowser} from '@local/utils/browser'

export const useLayoutEffect = isBrowser ? vanillaUseLayoutEffect : useEffect

export default useLayoutEffect
